import { render, staticRenderFns } from "./workShopTemplateInfo.vue?vue&type=template&id=71a2e31c"
import script from "./workShopTemplateInfo.vue?vue&type=script&lang=js"
export * from "./workShopTemplateInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports